import app from 'flarum/forum/app';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import username from '../../../../../vendor/flarum/core/js/src/common/helpers/username';
import Button from 'flarum/forum/components/Button';
import Stream from 'flarum/common/utils/Stream';


app.initializers.add('indigo/flarum-ext-custom-field', () => {
  console.log('[indigo/empresa-common] Hello, forum!');
	
extend(SignUpModal.prototype, 'fields', function(items) {
    items.add(
        'empresa',
        m('.Form-group', [
            m('input.FormControl', {
                name: 'empresa',
                type: 'text',
                id: 'empresa',
                placeholder: 'Empresa',
            })
        ]),
        10
    );
});

extend(SignUpModal.prototype, 'submitData', function (data) {
	//alert('teste');
	//console.log(data);
	data.empresa = document.getElementById('empresa').value;
	console.log(data);
	return data;
})

extend(SignUpModal.prototype, 'oninit', function () {
  this.empresa = Stream(this.attrs.username || '');
});




extend(UserCard.prototype, 'infoItems', function(items) {

//   let empr = document.getElementsByName(email).value
//   localStorage.setItem('empr', empr)

//   function returnText() {
//      empr = document.getElementsByName(email).value
//      localStorage.setItem('empr', empr)
//      alert(empr)
//   }

//   let usrname1 = "help!!!!!!"

//   items.add('teste', m("p", usrname1))  		   

//  items.add(
//  Button.component({
//  icon: 'fas fa-up', className:'Button Button-primary classeTeste'})) 
})

})
